<template>
  <portal-layout>
    <div class="favorite-page">
      <div class="page-head">
        <h2 class="page-title">我的收藏</h2>
      </div>

      <div v-loading="loading" class="favorite-card">
        <div v-if="!loading && records.length === 0" class="empty-tip">
          您还没有收藏任何商品
          <el-button type="text" @click="goShop">去逛逛</el-button>
        </div>

        <div v-else class="favorite-list">
          <div v-for="item in records" :key="item.commodityCode" class="favorite-item">
            <div class="item-cover" @click="goDetail(item)">
              <img :src="item.shopCommondityResVo.mainPic" :alt="item.shopCommondityResVo.title" />
            </div>
            <div class="item-info" @click="goDetail(item)">
              <div class="item-title">{{ item.shopCommondityResVo.title }}</div>
              <div class="item-subtitle">{{ item.shopCommondityResVo.subtitle }}</div>
              <div class="item-price">
                <span class="actual-price">¥{{ item.shopCommondityResVo.actualPrice }}</span>
                <span class="original-price">¥{{ item.shopCommondityResVo.totalPrice }}</span>
              </div>
            </div>
            <div class="item-action">
              <el-button type="text" class="remove-btn" @click="removeFavorite(item)">
                取消收藏
              </el-button>
            </div>
          </div>
        </div>
      </div>

      <div v-if="total > 0" class="pagination-container">
        <el-pagination background layout="total, prev, pager, next" :total="total"
                       :current-page.sync="pageNum" :page-size="pageSize"
                       @current-change="queryFavorites"></el-pagination>
      </div>
    </div>
  </portal-layout>
</template>
<script>
import PortalLayout from '@/components/PortalLayout.vue';
import api from '@/common/api';
import storage from '@/common/storage.js';

export default {
  name: 'PortalShopFavorite',
  components: { PortalLayout },
  data() {
    return {
      loading: false,
      records: [],
      total: 0,
      pageNum: 1,
      pageSize: 10
    }
  },
  created() {
    if (!this.checkLogin()) {
      return;
    }
    this.queryFavorites();
  },
  methods: {
    checkLogin() {
      if (!storage.getString('portalMember')) {
        if (this.$route.name === 'PortalLogin') return false;
        this.$router.push({ name: 'PortalLogin', query: { redirect: this.$route.fullPath } }).catch(() => {});
        return false;
      }
      return true;
    },
    queryFavorites() {
      this.loading = true;
      api.query_shop_favorite({
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }).then((r) => {
        if (r.data.code === "200") {
          // 后端 R.ok(page) 走 data 字段，返回 MyBatis-Plus 分页对象
          const page = r.data.data || {};
          this.records = page.records || [];
          this.total = page.total || 0;
        }
      }).catch(() => {
        // 401 已由 common/api.js 统一跳转登录页
      }).finally(() => {
        this.loading = false;
      });
    },
    // 后端 updateShopFavorite 是「切换」语义，已收藏再调一次即为取消
    removeFavorite(item) {
      api.update_shop_favorite({ commId: item.shopCommondityResVo.id }).then((r) => {
        if (r.data.code === "200") {
          this.$message.success('已取消收藏');
          this.queryFavorites();
        }
      }).catch(() => {});
    },
    goDetail(item) {
      this.$router.push('/portal/shop/detail?id=' + item.shopCommondityResVo.id).catch(() => {});
    },
    goShop() {
      this.$router.push('/portal/shop/list').catch(() => {});
    }
  }
};
</script>
<style scoped>
.page-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.page-title {
  font-size: 22px;
  color: #303133;
  margin: 0;
}
.favorite-card {
  background-color: #fff;
  border-radius: 8px;
  padding: 25px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  min-height: 200px;
}
.favorite-list {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}
.favorite-item {
  width: calc((100% - 60px) / 4);
  border: 1px solid #ebeef5;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s;
}
.favorite-item:hover {
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);
}
.item-cover {
  width: 100%;
  height: 140px;
  overflow: hidden;
  cursor: pointer;
  background-color: #f5f7fa;
}
.item-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.item-info {
  padding: 12px 15px 6px;
  cursor: pointer;
}
.item-title {
  font-size: 14px;
  color: #303133;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.item-subtitle {
  font-size: 12px;
  color: #909399;
  margin-top: 6px;
  height: 34px;
  line-height: 17px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.item-price {
  margin-top: 8px;
}
.actual-price {
  font-size: 16px;
  color: #F56C6C;
  font-weight: bold;
  margin-right: 8px;
}
.original-price {
  font-size: 12px;
  color: #c0c4cc;
  text-decoration: line-through;
}
.item-action {
  padding: 0 15px 12px;
  text-align: right;
}
.remove-btn {
  font-size: 13px;
  color: #909399;
}
.remove-btn:hover {
  color: #F56C6C;
}
.empty-tip {
  text-align: center;
  color: #909399;
  padding: 60px 0;
  font-size: 14px;
}
.pagination-container {
  margin-top: 20px;
  text-align: right;
}
@media (max-width: 1000px) {
  .favorite-item {
    width: calc((100% - 20px) / 2);
  }
}
</style>
